import { apiFetch } from './http';

/**
 * Channels API (cutover §3). The read surface is LIVE over the existing
 * 1789900004 collections; test-send is an honest 501 backend stub while no
 * channel transport exists (dry-run gate, §5).
 */

/** The session tenant's channels + routing rules in one read:
 * { channels: [...], routingRules: [...] }. */
export function getChannels() {
  return apiFetch('/api/channels');
}

/** Probe a channel's delivery path. Honest 501 today — the surface exists so
 * the wiring is real; the UI surfaces the "not yet live" message instead of
 * simulating a delivery. */
export function testChannelDelivery(channelId, payload) {
  return apiFetch(`/api/channels/${channelId}/test-send`, {
    body: JSON.stringify(payload),
    method: 'POST'
  });
}

export function getChannel(id) {
  return apiFetch(`/api/channels/${id}`);
}

export function createRoutingRule(rule) {
  return apiFetch('/api/channels/routing-rules', {
    body: JSON.stringify(rule),
    method: 'POST'
  });
}

export function deleteRoutingRule(ruleId) {
  return apiFetch(`/api/channels/routing-rules/${ruleId}`, { method: 'DELETE' });
}

export function sendTestMessage(channelType, payload) {
  return apiFetch(`/api/channels/${channelType}/test`, {
    body: JSON.stringify(payload),
    method: 'POST'
  });
}

export function getRateLimits() {
  return apiFetch('/api/channels/rate-limits');
}
